/**
 *  @class
 *  @function ToggleBoxes
 */
if (!customElements.get("toggle-box")) {
  class ToggleBox extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const link = this.querySelector(".toggle-box--image a");
      const button = this.querySelector(".toggle-box--button");

      if (!link) return;

      const navigate = () => {
        window.location.href = link.href;
      };

      // Make the entire card (including button) act as a link
      this.addEventListener("click", (event) => {
        // Let native anchor clicks behave normally
        if (event.target.tagName?.toLowerCase() === "a") return;
        navigate();
      });

      if (button) {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          navigate();
        });
      }
    }
  }
  customElements.define("toggle-box", ToggleBox);
}
